<template>
  <div class="container">
    <!-- 打印机列表 -->
    <div v-if="list.length && !showAddPrinter" class="printer-list">
      <div class="printer-list-title">
        <h3>已添加设备</h3>
        <el-button round @click="onClickAdd">添加新设备</el-button>
      </div>
      <div class="printer-item" v-for="item in list" :key="item.id">
        <div class="printer-item-left">
          <img class="printer-item-icon" src="../../../assets/images/print-icon.png" />
          <div class="printer-item-position">
            <template v-if="!item.editing">
              <span style="margin-left: 5px;">{{ item.name }}</span>
              <i class="el-icon-edit" style="margin-left: 5px; cursor: pointer;" @click="item.editing = true"></i>
            </template>
            <el-input v-if="item.editing" style="width: 100px;" type="text" size="mini" v-model="item.name">
              <div class="printer-item-input-suffix-wrap" slot="suffix">
                <i class="el-icon-check" @click="updateRow(item)"></i>
              </div>
            </el-input>
          </div>
        </div>
        <div class="printer-item-right">
          <div class="printer-item-close" @click="deleteRow(item)">
            <i class="el-icon-close" style="cursor: pointer;"></i>
          </div>
        </div>
      </div>
    </div>
    <!-- 添加打印机 -->
    <div v-if="showAddPrinter" class="add-printer">
      <img class="add-printer-bg" src="../../../assets/images/print-bg.png" />
      <div class="add-printer-right">
        <h3 class="add-printer-title">添加打印机</h3>
        <div class="add-printer-sub-title">目前仅支持 易联云K6打印机，如暂未拥有可点击 <a class="no-printer-link" href="https://www.yilianyun.net/products/K6Summarize" target="_blank">了解详情</a></div>
        <el-form class="add-printer-form" label-width="95px" label-position="left" size="small">
          <el-form-item label="打印机位置">
            <el-input placeholder="如厨房, 吧台等" v-model="row.name"></el-input>
          </el-form-item>
          <el-form-item label="终端号">
            <el-input placeholder="请输入终端号" v-model="row.machinecode"></el-input>
          </el-form-item>
          <el-form-item label="终端密钥">
            <el-input placeholder="请输入终端密钥" v-model="row.msign"></el-input>
          </el-form-item>
        </el-form>
        <div class="add-printer-comment">终端号与密钥见左图位置</div>
        <el-button class="add-printer-button" type="primary" round @click="addRow">确认添加</el-button>
        <el-button class="add-printer-button" round @click="showAddPrinter = false">取消</el-button>
      </div>
    </div>
    <!-- 无打印机 -->
    <div v-if="!list.length" class="no-printer">
      <img src="../../../assets/images/print-icon.png" alt="打印机" class="no-printer-icon" />
      <div class="no-printer-title">暂未添加打印机</div>
      <div class="no-printer-sub-title">目前支持 易联云K6打印机，如暂未拥有可点击 <a class="no-printer-link" href="https://www.yilianyun.net/products/K6Summarize" target="_blank">了解详情</a></div>
      <el-button class="no-printer-button" type="primary" @click="onClickAdd" round>立即添加</el-button>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { M } from '../../../service/grpc.js';
import { rpc } from '../../../service/index.js';
import { getToken } from '../../../service/helper.js';

export default {
  data() {
    return {
      token: getToken(),
      showAddPrinter: false,
      row: {},
      list: []
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    async getList() {
      const res = await rpc(
        'StorePrinterService.GetPrinterList',
        M('PrinterListQueryRequest', {
          token: M('Token', { token: this.token }),
          count: 100
        })
      );
      res.printerlistList.forEach(v => (v.editing = false));
      this.list = res.printerlistList;
    },

    onClickAdd() {
      this.row = {};
      this.showAddPrinter = true;
    },
    async addRow() {
      const res = await rpc(
        'StorePrinterService.CreatePrinter',
        M('PrinterWithTokenRequest', {
          token: M('Token', { token: this.token }),
          printer: M('Printer', this.row)
        })
      );
      res.editing = false;
      this.list.splice(0, 0, res);
      this.showAddPrinter = false;
    },
    async updateRow(row) {
      await rpc(
        'StorePrinterService.UpdatePrinter',
        M('PrinterWithTokenRequest', {
          token: M('Token', { token: this.token }),
          printer: M('Printer', row)
        })
      );
      row.editing = false;
    },
    async deleteRow(row) {
      await rpc(
        'StorePrinterService.DeletePrinter',
        M('IDWithTokenRequest', {
          token: M('Token', { token: this.token }),
          id: row.id
        })
      );
      this.list.splice(this.list.findIndex(v => v.id === row.id), 1);
    }
  }
};
</script>

<style>
/* 打印机列表 */
.printer-list {
  height: calc(100vh - 110px);
}
.printer-list-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 350px;
}
.printer-item {
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  border: 1px solid #e8e8e8;
  padding: 15px;
  background-color: #f5f5f5;
  width: 320px;
}
.printer-item-left {
  display: flex;
  align-items: center;
}
.printer-item-right {
  display: flex;
  align-items: center;
}
.printer-item-icon {
  margin-top: -1px;
  width: 18px;
  height: 18px;
}
.printer-item-position {
  height: 26px;
  display: flex;
  align-items: center;
  margin-left: 5px;
}
.printer-item-input-suffix-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 20px;
}
.printer-item-status {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 60px;
  border-radius: 12px;
}
.printer-item-status.error {
  background-color: rgb(251, 235, 234);
  color: rgb(206, 55, 46);
}
.printer-item-status.online {
  background-color: rgb(237, 244, 237);
  color: rgb(104, 153, 110);
}
.printer-item-status.warning {
  background-color: rgb(247, 238, 231);
  color: rgb(232, 109, 44);
}
.printer-item-status.offline {
  background-color: rgb(240, 237, 242);
  color: rgb(141, 130, 154);
}
.printer-item-close {
  line-height: 30px;
  height: 30px;
  font-size: 20px;
  padding-left: 15px;
  margin-left: 15px;
  border-left: 1px solid #e8e8e8;
  color: #999;
}

/* 添加打印机 */
.add-printer {
  height: calc(100vh - 110px);
  display: flex;
  align-items: center;
  justify-content: center;
}
.add-printer-bg {
  width: 420px;
  height: 390px;
}
.add-printer-right {
  width: 420px;
  margin-left: 50px;
}
.add-printer-link {
  color: rgb(49, 84, 131);
}
.add-printer-title {
  margin-top: 20px;
  font-size: 18px;
  font-weight: 700;
  color: #666;
}
.add-printer-sub-title {
  margin-top: 10px;
  font-size: 14px;
  color: #666;
}
.add-printer-form {
  margin-top: 20px;
  width: 280px;
}
.add-printer-comment {
  font-size: 12px;
  color: #999;
}
.add-printer-button {
  margin-top: 20px;
}

/* 无打印机 */
.no-printer {
  height: calc(100vh - 110px);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.no-printer-icon {
  width: 40px;
  height: 38px;
}
.no-printer-link {
  color: rgb(49, 84, 131);
}
.no-printer-title {
  margin-top: 20px;
  font-size: 18px;
  font-weight: 700;
  color: #666;
}
.no-printer-sub-title {
  margin-top: 10px;
  font-size: 14px;
  color: #666;
}
.no-printer-button {
  margin-top: 30px;
}
</style>
